/**
 * Calculates the room-only total price for a booking.
 * 
 * If a custom price is set, it uses that as the room total.
 * Otherwise, it calculates the room total by subtracting activity-related costs
 * from the total price.
 * 
 * @param {Object} booking - The booking object
 * @param {number} [booking.custom_price] - Custom room price (takes precedence if > 0)
 * @param {number} [booking.total_price] - Total booking price including activities
 * @param {number} [booking.activity_price] - Activity price to subtract
 * @param {number} [booking.activity_tax] - Activity tax to subtract
 * @returns {number} The room-only total price
 */
export const getRoomOnlyTotal = (booking) => {
  if (booking?.custom_price > 0) {
    // custom_price is the room total
    return booking.custom_price;
  }
  // total_price includes activities, so subtract them
  return (
    (booking?.total_price || 0) -
    (booking?.activity_price || 0) -
    (booking?.activity_tax || 0)
  );
};